var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flex',{staticClass:"view centered",attrs:{"id":"contact"},on:{"submit":function($event){$event.preventDefault();return _vm.send($event)}}},[_c('contact-form',{attrs:{"contact":_vm.contact}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }